/* n2 matcha storefront redesign v4 — shared behavior
   quick-add, quizzes (powders + loose leaf), flight builders (multi-instance),
   cost-per-bowl, sticky atc, cart nudge, intro splash. */
(function () {
  'use strict';
  if (window.__n2Redesign) return; window.__n2Redesign = true;

  var NUDGE = {
    thresholdCents: 10000,                   // nz$100 free-shipping threshold
    windowCents: 3000,                       // nudge when ≤ nz$30 remains
    sifterVariantId: 48576176947423,
    sifterPriceCents: 3000
  };

  function money(cents) {
    var n = cents / 100;
    return 'nz$' + (n % 1 === 0 ? n : n.toFixed(2));
  }

  /* ---------- cart add (single or multi line) ---------- */
  function addToCart(items, button, cb) {
    fetch(window.theme && theme.routes && theme.routes.cart_add_url ? theme.routes.cart_add_url + '.js' : '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) { return r.json().then(function (json) { return { ok: r.ok, json: json }; }); })
      .then(function (res) {
        if (!res.ok) {
          document.dispatchEvent(new CustomEvent('theme:product:add-error', {
            detail: { response: res.json, button: button }, bubbles: true
          }));
          return;
        }
        document.dispatchEvent(new CustomEvent('theme:product:add', {
          detail: { response: res.json, button: button }, bubbles: true
        }));
        document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
        if (window.kachingCartApi) {
          /* store runs the Kaching Cart drawer app — drive it directly */
          Promise.resolve(window.kachingCartApi.refreshCart()).then(function () {
            window.kachingCartApi.openCart();
          });
        } else {
          /* Broadcast native drawer: refresh happens via theme:cart:refresh, then open */
          setTimeout(function () {
            document.dispatchEvent(new CustomEvent('theme:product:added', {
              detail: { button: button }, bubbles: true
            }));
          }, 600);
        }
        if (cb) cb(res.json);
      })
      .catch(function () {});
  }
  window.n2AddToCart = addToCart;

  /* any element: <button data-n2-add data-variant-id="123" data-properties='{"..":".."}'> */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-n2-add]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var id = parseInt(btn.dataset.variantId, 10);
    if (!id) return;
    var props;
    try { props = btn.dataset.properties ? JSON.parse(btn.dataset.properties) : undefined; } catch (err) {}
    addToCart([{ id: id, quantity: 1, properties: props }], btn);
  });

  /* whole product card click-through (quick-add stops propagation above) */
  document.addEventListener('click', function (e) {
    var card = e.target.closest('[data-n2-card-url]');
    if (!card || e.target.closest('a, button')) return;
    window.location.href = card.dataset.n2CardUrl;
  });

  /* ---------- collection tabs ---------- */
  document.addEventListener('click', function (e) {
    var tab = e.target.closest('[data-n2-tab]');
    if (!tab) return;
    var scope = tab.closest('[data-n2-tabs]');
    if (!scope) return;
    scope.querySelectorAll('[data-n2-tab]').forEach(function (t) {
      t.classList.toggle('is-active', t === tab);
    });
    scope.querySelectorAll('[data-n2-panel]').forEach(function (p) {
      p.hidden = p.dataset.n2Panel !== tab.dataset.n2Tab;
    });
  });

  /* ---------- quizzes (tea powders + loose leaf) ---------- */
  var quizzes = {
    loose: {
      title: 'the loose leaf quiz',
      steps: [
        { key: 'adv', q: 'classic or curveball?', options: [
          { label: 'something i can trust', val: 'classic' },
          { label: 'surprise me', val: 'surprise' }
        ]},
        { key: 'mood', q: 'right now you want…', options: [
          { label: 'green, marine, a bit of umami', val: 'marine' },
          { label: 'sweet, nutty, pan-fired green', val: 'nutty' },
          { label: 'delicate, sweet, barely any bite', val: 'delicate' },
          { label: 'toasty, mellow, impossible to ruin', val: 'toasty' },
          { label: 'floral & silky — fresh oolong', val: 'floral' },
          { label: 'honeyed & fruity — a deeper oolong', val: 'honey' }
        ]}
      ],
      result: function (a) {
        if (a.adv === 'surprise') return 'mystery-loose-leaf-tea-june-2026';
        if (a.mood === 'floral') return 'fresh-four-season-oolong-nantou';
        if (a.mood === 'honey') return 'taitung-red-oolong-taitung';
        if (a.mood === 'nutty') return 'west-lake-longjing-zhejiang';
        if (a.mood === 'delicate') return 'anji-bai-cha-zhejiang';
        return a.mood === 'marine' ? 'saemidori-sencha-kagoshima' : 'yabukita-green-hojicha-very-light-roast-kagoshima';
      }
    }
  };
  var quiz = {
    title: 'the tea match quiz',
    steps: [
      { key: 'drink', q: 'how are you drinking it?', options: [
        { label: 'whisked in a bowl, no milk', val: 'straight' },
        { label: 'latte', val: 'latte' },
        { label: 'iced', val: 'straight' },
        { label: 'actually, i want loose leaf', val: 'leaf' }
      ]},
      { key: 'bitter', q: 'bitterness?', options: [
        { label: 'love a bit of grip', val: 'love' },
        { label: 'a little is fine', val: 'some' },
        { label: 'keep it sweet', val: 'none' }
      ]},
      { key: 'caf', q: 'caffeine?', options: [
        { label: 'full send', val: 'full' },
        { label: 'gentle', val: 'low' },
        { label: "it's 9 pm", val: 'none' }
      ]},
      { key: 'adv', q: 'classic or curveball?', options: [
        { label: 'the classic', val: 'classic' },
        { label: 'surprise me', val: 'surprise' }
      ]},
      { key: 'depth', q: 'how deep are you going?', options: [
        { label: 'starting small', val: 'small' },
        { label: 'all in', val: 'allin' }
      ]}
    ],
    step: 0,
    answers: {}
  };
  quizzes.powders = quiz;
  /* combined entry point: first question routes to powders or loose leaf */
  quizzes.combo = {
    combo: true,
    title: 'the tea match quiz',
    steps: [
      { key: 'type', q: 'first things first — powder or leaf?', options: [
        { label: 'powder. whisked, lattes, iced', val: 'powders' },
        { label: 'leaf. a pot & a bit of patience', val: 'loose' }
      ]}
    ],
    step: 0,
    answers: {},
    result: function () { return ''; }
  };
  quiz.result = function (a) { return quizResultHandle(a); };
  var activeQuiz = quiz;
  var activeEntry = 'powders'; /* which quiz the modal was opened with — retake returns here */
  var quizHistory = []; /* [{q, step}] so the back button can retrace, incl. across the combo handover */

  /* ported as-is from the prototype's quizResult(), keyed by product handle */
  function quizResultHandle(a) {
    if (a.caf === 'none') return 'yabukita-hojicha-dark-roast-shizuoka';
    if (a.drink === 'leaf') {
      if (a.adv === 'surprise') return 'mystery-loose-leaf-tea-june-2026';
      return a.depth === 'allin' ? 'saemidori-sencha-kagoshima' : 'yabukita-green-hojicha-very-light-roast-kagoshima';
    }
    if (a.drink === 'latte') return a.adv === 'surprise' ? 'da-hong-pao-big-red-robe-fujian' : 'earl-grey-sri-lanka';
    if (a.adv === 'surprise') return 'qimen-black-tea-anhui';
    if (a.caf === 'low') return 'brown-rice-yellow-tea-powder';
    if (a.bitter === 'none') return 'saemidori-matcha-shiga';
    return 'yabukita-matcha-uji';
  }

  function quizProducts() {
    /* merge every quiz-products JSON on the page (powders + loose flights) */
    var map = {};
    document.querySelectorAll('[data-n2-quiz-products]').forEach(function (el) {
      try {
        var data = JSON.parse(el.textContent);
        Object.keys(data).forEach(function (k) { map[k] = data[k]; });
      } catch (e) {}
    });
    return map;
  }

  /* modal shell is built once by js so any number of quiz tiles can share it */
  function ensureQuizModal() {
    if (document.querySelector('.n2-quiz-modal')) return;
    var overlay = document.createElement('div');
    overlay.className = 'n2-quiz-overlay';
    overlay.setAttribute('data-n2-quiz-close', '');
    var modal = document.createElement('div');
    modal.className = 'n2-quiz-modal';
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.innerHTML = '<div style="display:flex;justify-content:space-between;align-items:baseline">' +
      '<h3 data-n2-quiz-title></h3>' +
      '<button type="button" class="n2-quiz-close" data-n2-quiz-close aria-label="close">✕</button></div>' +
      '<div data-n2-quiz-body></div>';
    document.body.appendChild(overlay);
    document.body.appendChild(modal);
  }

  function renderQuiz() {
    var body = document.querySelector('[data-n2-quiz-body]');
    if (!body) return;
    var title = document.querySelector('[data-n2-quiz-title]');
    if (title) title.textContent = activeQuiz.title;
    var html = '';
    if (activeQuiz.step < activeQuiz.steps.length) {
      var s = activeQuiz.steps[activeQuiz.step];
      if (activeQuiz.steps.length > 1) {
        html += '<div class="n2-mono" style="margin-top:14px">question ' + (activeQuiz.step + 1) + ' of ' + activeQuiz.steps.length + '</div>';
      }
      html += '<div class="n2-quiz-q">' + s.q + '</div>';
      s.options.forEach(function (o, i) {
        html += '<button type="button" class="n2-quiz-opt" data-n2-quiz-pick="' + i + '">' + o.label + '</button>';
      });
      if (quizHistory.length) html += '<button type="button" class="n2-quiz-retake" data-n2-quiz-back>← back</button>';
    } else {
      var p = quizProducts()[activeQuiz.result(activeQuiz.answers)];
      if (p) {
        html += '<div class="n2-mono" style="margin-top:14px">your match</div>';
        html += '<div class="n2-quiz-result-title">' + p.title + '</div>';
        html += '<div class="n2-notes" style="font-size:15px;margin-top:5px">' + (p.notes || '') + '</div>';
        html += '<div style="display:flex;gap:10px;margin-top:18px;flex-wrap:wrap">';
        if (p.available) html += '<button type="button" class="n2-btn" data-n2-add data-variant-id="' + p.variantId + '">add to cart — ' + money(p.priceCents) + '</button>';
        html += '<a class="n2-btn n2-btn--ghost" href="' + p.url + '">read the specs</a></div>';
        if (quizHistory.length) html += '<button type="button" class="n2-quiz-retake" data-n2-quiz-back style="margin-right:16px">← back</button>';
        html += '<button type="button" class="n2-quiz-retake" data-n2-quiz-retake>retake</button>';
      }
    }
    body.innerHTML = html;
  }

  function openQuiz(type) {
    ensureQuizModal();
    activeEntry = quizzes[type] ? type : 'powders';
    activeQuiz = quizzes[type] || quizzes.powders;
    activeQuiz.step = 0; activeQuiz.answers = {};
    quizHistory = [];
    document.querySelectorAll('.n2-quiz-overlay, .n2-quiz-modal').forEach(function (el) { el.classList.add('is-open'); });
    renderQuiz();
  }
  function closeQuiz() {
    document.querySelectorAll('.n2-quiz-overlay, .n2-quiz-modal').forEach(function (el) { el.classList.remove('is-open'); });
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-n2-quiz-open]');
    if (opener) { e.preventDefault(); openQuiz(opener.getAttribute('data-n2-quiz-open') || 'powders'); return; }
    if (e.target.closest('[data-n2-quiz-close]') || e.target.matches('.n2-quiz-overlay')) { closeQuiz(); return; }
    var back = e.target.closest('[data-n2-quiz-back]');
    if (back) {
      var h = quizHistory.pop();
      if (h) { activeQuiz = h.q; activeQuiz.step = h.step; renderQuiz(); }
      return;
    }
    var pick = e.target.closest('[data-n2-quiz-pick]');
    if (pick) {
      var s = activeQuiz.steps[activeQuiz.step];
      var val = s.options[parseInt(pick.dataset.n2QuizPick, 10)].val;
      activeQuiz.answers[s.key] = val;
      quizHistory.push({ q: activeQuiz, step: activeQuiz.step });
      if (activeQuiz.combo) {
        /* hand over to the picked quiz inside the same modal */
        activeQuiz = quizzes[val] || quizzes.powders;
        activeQuiz.step = 0; activeQuiz.answers = {};
        renderQuiz();
        return;
      }
      activeQuiz.step++;
      renderQuiz();
      return;
    }
    if (e.target.closest('[data-n2-quiz-retake]')) {
      /* back to the very start — including the powder-or-leaf question if that's how it opened */
      activeQuiz = quizzes[activeEntry] || quizzes.powders;
      activeQuiz.step = 0; activeQuiz.answers = {};
      quizHistory = [];
      renderQuiz();
    }
    if (e.target.closest('[data-n2-add]') && e.target.closest('.n2-quiz-modal')) closeQuiz();
  });

  /* ---------- flight builder (multi-instance) ---------- */
  /* each [data-n2-flight] configurator keeps its own picks. at data-gift-at or
     more, the gift product (data-gift-variant) is added automatically — it rings
     up free via the "free sifter with 5+ teas" automatic discount. */
  function flightState(scope) {
    if (!scope._n2flight) scope._n2flight = [];
    return scope._n2flight; // [{handle, short, variants:[...], chosen: index}]
  }

  function flightGiftDue(scope) {
    var at = parseInt(scope.dataset.giftAt || '0', 10);
    return !!(at && scope.dataset.giftVariant && flightState(scope).length >= at);
  }

  function flightRender(scope) {
    if (!scope) return;
    var flight = flightState(scope);
    var min = parseInt(scope.dataset.min || '3', 10);
    var rows = scope.querySelector('[data-n2-flight-rows]');
    var totalEl = scope.querySelector('[data-n2-flight-total]');
    var cta = scope.querySelector('[data-n2-flight-add]');
    var giftBox = scope.querySelector('[data-n2-flight-gift]');
    scope.querySelectorAll('[data-n2-flight-chip]').forEach(function (chip) {
      chip.classList.toggle('is-on', flight.some(function (f) { return f.handle === chip.dataset.handle; }));
    });
    var html = '', total = 0;
    flight.forEach(function (f) {
      var v = f.variants[f.chosen];
      total += v.priceCents;
      html += '<div class="n2-flight-row"><span class="n2-flight-row__name">' + f.short + '</span>';
      f.variants.forEach(function (vv, i) {
        html += '<button type="button" class="n2-flight-size' + (i === f.chosen ? ' is-on' : '') + '" data-n2-flight-size data-handle="' + f.handle + '" data-i="' + i + '">' + vv.label + '</button>';
      });
      html += '</div>';
    });
    if (rows) rows.innerHTML = html;
    if (totalEl) totalEl.textContent = flight.length ? money(total) : (scope.dataset.fromLabel || '');
    if (giftBox) {
      var due = flightGiftDue(scope);
      var giftAt = parseInt(scope.dataset.giftAt || '0', 10);
      var hasGift = !!scope.dataset.giftVariant;
      giftBox.hidden = !hasGift || (!due && !(giftAt && flight.length === giftAt - 1));
      var txt = giftBox.querySelector('[data-n2-flight-gift-text]');
      if (txt && hasGift) {
        txt.textContent = due
          ? (scope.dataset.giftDueText || ((scope.dataset.giftLabel || 'gift') + ' — on me. it’s in your flight.'))
          : (scope.dataset.giftNearText || ('one more tea and the ' + (scope.dataset.giftLabel || 'gift') + ' is on me.'));
      }
    }
    if (cta) {
      var ready = flight.length >= min;
      cta.classList.toggle('is-disabled', !ready);
      cta.textContent = ready ? 'add my flight' : 'pick ' + (min - flight.length) + ' more';
    }
  }

  document.addEventListener('click', function (e) {
    var chip = e.target.closest('[data-n2-flight-chip]');
    if (chip) {
      var scope = chip.closest('[data-n2-flight]');
      var flight = flightState(scope);
      var data = JSON.parse(chip.dataset.product);
      var i = flight.findIndex(function (f) { return f.handle === data.handle; });
      if (i >= 0) flight.splice(i, 1);
      else flight.push({ handle: data.handle, short: data.short, variants: data.variants, chosen: 0 });
      flightRender(scope);
      return;
    }
    var size = e.target.closest('[data-n2-flight-size]');
    if (size) {
      var scope = size.closest('[data-n2-flight]');
      var f = flightState(scope).find(function (x) { return x.handle === size.dataset.handle; });
      if (f) { f.chosen = parseInt(size.dataset.i, 10); flightRender(scope); }
      return;
    }
    var add = e.target.closest('[data-n2-flight-add]');
    if (add && !add.classList.contains('is-disabled')) {
      var scope = add.closest('[data-n2-flight]');
      var flight = flightState(scope);
      var min = parseInt(scope.dataset.min || '3', 10);
      if (flight.length < min) return;
      var items = flight.map(function (f) {
        return { id: f.variants[f.chosen].id, quantity: 1, properties: { _flight: 'tasting flight' } };
      });
      if (flightGiftDue(scope)) {
        items.push({
          id: parseInt(scope.dataset.giftVariant, 10),
          quantity: 1,
          properties: { _flight: 'tasting flight', _gift: 'free with ' + scope.dataset.giftAt + '+ teas' }
        });
      }
      addToCart(items, add, function () { scope._n2flight = []; flightRender(scope); });
    }
  });
  document.querySelectorAll('[data-n2-flight]').forEach(flightRender);

  /* ---------- pdp: cost-per-bowl + sticky atc ---------- */
  function calcRender() {
    var calc = document.querySelector('[data-n2-calc]');
    if (!calc) return;
    var dose = parseFloat(calc.dataset.dose || '2');
    var grams = parseFloat(calc.dataset.grams || '0');
    var priceCents = parseFloat(calc.dataset.priceCents || '0');
    if (!grams || !priceCents) { calc.hidden = true; return; }
    calc.hidden = false;
    var servesExact = Math.max(1, grams / dose);
    var serves = Math.max(1, Math.round(servesExact));
    var out = calc.querySelector('[data-n2-calc-out]');
    if (out) out.innerHTML = '<span class="n2-calc-price">nz$' + (priceCents / 100 / servesExact).toFixed(2) + '</span>' +
      '<span class="n2-calc-sub">' + (calc.dataset.perLabel || 'per bowl') + ' · about ' + serves + ' serves in the ' + calc.dataset.label + '</span>';
    calc.querySelectorAll('[data-n2-dose]').forEach(function (b) {
      b.classList.toggle('is-on', parseFloat(b.dataset.n2Dose) === dose);
    });
  }
  document.addEventListener('click', function (e) {
    var d = e.target.closest('[data-n2-dose]');
    if (d) {
      var calc = e.target.closest('[data-n2-calc]');
      calc.dataset.dose = d.dataset.n2Dose;
      /* keep whatever the customer typed in the custom field */
      calcRender();
    }
  });
  /* custom serving size input */
  document.addEventListener('input', function (e) {
    var inp = e.target.closest('[data-n2-dose-input]');
    if (!inp) return;
    var g = parseFloat(inp.value);
    if (!g || g <= 0) return;
    var calc = inp.closest('[data-n2-calc]');
    calc.dataset.dose = g;
    calcRender();
  });
  window.n2CalcUpdate = function (grams, priceCents, label) {
    var calc = document.querySelector('[data-n2-calc]');
    if (!calc) return;
    calc.dataset.grams = grams || 0;
    calc.dataset.priceCents = priceCents;
    calc.dataset.label = label;
    calcRender();
  };
  calcRender();

  var sticky = document.querySelector('[data-n2-sticky]');
  if (sticky) {
    window.addEventListener('scroll', function () {
      sticky.classList.toggle('is-shown', window.scrollY > 560);
    }, { passive: true });
  }

  /* ---------- cart drawer: sifter nudge (native Broadcast drawer only) ---------- */
  function refreshNudge() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var existing = drawer.querySelector('.n2-nudge');
        var remaining = NUDGE.thresholdCents - cart.total_price;
        var hasSifter = cart.items.some(function (i) { return i.variant_id === NUDGE.sifterVariantId; });
        var show = cart.item_count > 0 && remaining > 0 && remaining <= NUDGE.windowCents && !hasSifter;
        if (!show) { if (existing) existing.remove(); return; }
        if (existing) return;
        var box = document.createElement('div');
        box.className = 'n2-nudge';
        box.innerHTML = '<span class="n2-nudge__text">the <b>sifter (' + money(NUDGE.sifterPriceCents) + ')</b> would tip it over. just saying.</span>' +
          '<button type="button" class="n2-nudge__btn" data-n2-add data-variant-id="' + NUDGE.sifterVariantId + '">add it</button>';
        var items = drawer.querySelector('[data-items-holder]');
        if (items && items.parentNode) items.parentNode.insertBefore(box, items);
      })
      .catch(function () {});
  }
  document.addEventListener('theme:cart-drawer:open', function () { setTimeout(refreshNudge, 400); });
  document.addEventListener('theme:cart:change', function () { setTimeout(refreshNudge, 400); });
  document.addEventListener('theme:product:add', function () { setTimeout(refreshNudge, 600); });

  /* ---------- intro splash ---------- */
  var intro = document.querySelector('[data-n2-intro]');
  if (intro) {
    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var seen = false;
    try { seen = !!sessionStorage.getItem('n2introSeen'); } catch (e) {}
    if (reduced || seen || (window.Shopify && Shopify.designMode)) {
      intro.remove();
    } else {
      try { sessionStorage.setItem('n2introSeen', '1'); } catch (e) {}
      var kill = function () {
        intro.classList.add('is-leaving');
        setTimeout(function () { intro.remove(); }, 500);
      };
      var t = setTimeout(kill, 2200);
      var skip = intro.querySelector('[data-n2-intro-skip]');
      if (skip) skip.addEventListener('click', function () { clearTimeout(t); kill(); });
    }
  }
})();
